import React, {useEffect, useState} from "react";
import {getAmountLabel, getFormattedMessage} from "../../../helpers/helpers";
import PlanSelectItem from "./PlanSelectItem";
import ArrowItem from "../items/ArrowItem";

const PlanSubscriptionChangeConfirm = ({selectedPlan, previousPlanLabel, doNotRenew, newlySelectedPlanLabel}) => {
    return (
        <div className={'row'}>
            <div className={'col-1'}/>
            <div className={'col-4'}>
                <PlanSelectItem label1={previousPlanLabel}
                                label2={getAmountLabel(selectedPlan?.oldPriceAmount, selectedPlan?.oldMonths)}
                                doNotRenew={doNotRenew}
                                readOnly={true}/>
            </div>
            <div className={'col-2'}>
                <ArrowItem/>
            </div>
            <div className={'col-4'}>
                <PlanSelectItem selected={true}
                                label1={newlySelectedPlanLabel}
                                label2={getAmountLabel(selectedPlan?.priceAmount, selectedPlan?.months)}
                                doNotRenew={doNotRenew}
                                readOnly={true}/>
            </div>
            <div className={'col-1'}/>
        </div>
    );
};

export default PlanSubscriptionChangeConfirm;